import React from 'react';
import { useProgress } from 'components/layout_and_quote_builder/utils/ProgressContext.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';

const ProgressBarOverlay = () => {
  const { progress } = useProgress();

  // Don't show overlay if there are no requests or all are completed
  if (progress.total === 0 || progress.completed === progress.total) {
    return null;
  }

  return (
    <div className={styles.progressOverlay}>
      <div className={styles.progressCard}>
        <div className={styles.progressTitle}>
          Loading Layout Combinations
        </div>

        {false && <div className={styles.progressStats}>
          {progress.completed} / {progress.total} requests completed
        </div>}

        <div className={styles.progressBarContainer}>
          <div
            className={styles.progressBarFill}
            style={{ width: `${progress.percentage}%` }}
          >
            <span className={styles.progressPercentage}>
              {progress.percentage}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBarOverlay;
